// Inter is the self-hosted fallback; Apple devices use the system San Francisco face first.
import '@fontsource-variable/inter/opsz.css';
import './styles/tokens.css';
import './styles/app.css';
import { start } from './ui/app';

start();
